/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  let registration = null

  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      // Service worker is active
    },

    registered(reg) {
      registration = reg
      window.swRegistration = reg

      // Periodic update check every 30 minutes
      setInterval(() => {
        if (registration) registration.update()
      }, 30 * 60 * 1000)
    },

    cached() {
      // Content cached for offline use
    },

    updatefound() {
      const installingWorker = registration?.installing
      if (!installingWorker) return

      installingWorker.addEventListener('statechange', () => {
        if (installingWorker.state === 'installed' && navigator.serviceWorker.controller) {
          // New version installed and waiting to activate
          console.log('🆕 New service worker installed, waiting to activate')
          window.postMessage({ type: 'SW_UPDATE_FOUND' }, '*')
        }
      })
    },

    updated(reg) {
      console.log('✨ New content available - update ready')
      registration = reg
      window.swRegistration = reg
      window.postMessage({ type: 'SW_UPDATED' }, '*')
    },

    offline() {
      console.log('📡 App running in offline mode')
    },

    error(error) {
      if (process.env.NODE_ENV === 'development' &&
          error.message?.includes('InvalidStateError')) {
        return
      }
      console.error('❌ Service worker error:', error)
    }
  })
}
